import {Button} from './Button';
import buttoncss from "../css/button.module.css"
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";

const ModuleHeader = ({ tabs, selectedTab, onTabSelect }) => {

  const bookClosure = () => {
    window.location.href = "/myfinv2/book-closure";
  };

  return (
    <div className="moduleHeader">
      <h2 className="moduleHeaderTitle">Modules Library</h2>
      <div className="selected-info">
        <span className="selected-count">SELECTED</span>
        <span className="count">6 Templates | 4 Tasks</span>
        <Button
          label="Import tasks"
          btnColor={buttoncss.primary}
          icon={<PlusIcon />}
          onClick={bookClosure}
        />
      </div>
    </div>
  );
};

export default ModuleHeader;
